import { createFileRoute } from '@tanstack/react-router';
import Blog from '@/pages/Blog';
import { buildBreadcrumb, ldJson } from '@/lib/site-schema';
import { knowledgeArticles } from '@/data/knowledge';
const title = 'Conocimiento: IA, SEO y crecimiento | SEOEVOLUTION';
const description = 'Guías para decisiones empresariales: visibilidad en buscadores de IA, marketing y captación. SEO y GEO con criterio, sin promesas de posiciones.';
export const Route = createFileRoute('/blog/')({
  head: () => ({
    meta: [
      { title }, { name: 'description', content: description },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://agenciaseoevolution.com/blog' },
      { property: 'og:title', content: title }, { property: 'og:description', content: description },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: title }, { name: 'twitter:description', content: description },
    ],
    links: [{ rel: 'canonical', href: 'https://agenciaseoevolution.com/blog' }],
    scripts: [ldJson(buildBreadcrumb([{ name: 'Conocimiento', path: '/blog' }])), ldJson({
      '@context': 'https://schema.org', '@type': 'CollectionPage',
      name: 'IA, SEO y crecimiento empresarial', description, url: 'https://agenciaseoevolution.com/blog',
      mainEntity: { '@type': 'ItemList', itemListElement: knowledgeArticles.map((article, index) => ({ '@type': 'ListItem', position: index + 1, name: article.title, url: `https://agenciaseoevolution.com/blog/${article.slug}` })) },
    })],
  }),
  component: Blog,
});
